export const defaultPermissions = [
  // Note: List is sorted alphabetically on interface
  {
    id: 1,
    name: 'Admins',
    code: 'ADMIN',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within https://admin.getmarketfuel.io/admins'
  },
  {
    id: 2,
    name: 'Products',
    code: 'PRODUCT',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Products, Artworks and Configuration'
  },
  {
    id: 3,
    name: 'Orders',
    code: 'ORDER',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Orders List, Fulfilment, Order Approval, Failed Orders'
  },
  {
    id: 4,
    name: 'POs',
    code: 'PURCHASE_ORDER',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Purchase Orders'
  },
  {
    id: 5,
    name: 'Customers',
    code: 'USER',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Customers except Co-op, account credits, gift cards (permissioned seperately)'
  },
  {
    id: 6,
    name: 'Client Settings',
    code: 'CLIENT',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Clients'
  },
  {
    id: 7,
    name: 'Portal Settings',
    code: 'PORTAL',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Portal except Location Settings'
  },
  {
    id: 8,
    name: 'Locations',
    code: 'LOCATION',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Location Settings within Portal'
  },
  {
    id: 9,
    name: 'Inventory',
    code: 'WAREHOUSE',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Warehouse'
  },
  {
    id: 10,
    name: 'Artwork Switcher',
    code: 'ARTWORK',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'The art switcher available to Digital Proofing'
  },
  {
    id: 11,
    name: 'Reporting',
    code: 'REPORTING',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within reporting'
  },
  {
    id: 12,
    name: 'Feedback',
    code: 'FEEDBACK',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within feedback'
  },
  {
    id: 13,
    name: 'Promotions',
    code: 'COUPON',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Promotions'
  },
  {
    id: 14,
    name: 'Credits: Gift Cards',
    code: 'GIFT_CARD',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Gift Card of Customer Account'
  },
  {
    id: 15,
    name: 'Credits: Co-op $',
    code: 'COOP_CREDIT',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Ability to manipulate funds in co-op bank accounts'
  },
  {
    id: 16,
    name: 'Credits: Portal Credits',
    code: 'PORTAL_CREDIT',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Portal Credits Tab of Customer Account'
  },
  {
    id: 17,
    name: 'CMS',
    code: 'CMS',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Ability to create portal pages'
  },
  {
    id: 18,
    name: 'Sys Settings',
    code: 'SYSTEM',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Overall setting for Marketfuel System, CRUD only available to Super Admin'
  },
  {
    id: 19,
    name: 'Event Flyer',
    code: 'EVENT_FLYER',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Event Flyer for Digital Proofing'
  },
  {
    id: 20,
    name: 'Co-op Fn',
    code: 'COOP_FUNDING',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Ability to create, edit co-op bank accounts'
  },
  { id: 21, name: 'Product Wizard', code: 'PRODUCT_WIZARD', create: false, tooltip: 'Product Wizard Only' },
  { id: 22, name: 'Bundle Wizard', code: 'BUNDLE_WIZARD', create: false, tooltip: 'Bundle Wizard Only' },
  {
    id: 23,
    name: 'Customer Groups',
    code: 'CUST_GROUPS',
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'For Customer Groups on Product'
  },
  {
    id: 24,
    name: 'Payment',
    code: 'PAYMENT',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Payment'
  },
  {
    id: 25,
    name: 'Permissions',
    code: 'PERMISSIONS',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Roles and Permissions'
  },
  {
    id: 26,
    name: 'Vendors',
    code: 'VENDORS',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas with Vendors'
  },
  {
    id: 27,
    name: 'Dropship Batches',
    code: 'DROPSHIP_BATCH',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas with Dropship Batches'
  },
  {
    id: 28,
    name: 'Order Approval',
    code: 'ORDER_APPROVAL',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Viewing and updating order approvals'
  },
  {
    id: 29,
    name: 'Credits: Points',
    code: 'POINTS_CREDIT',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Points tab of Customer Account Credits'
  },
  {
    id: 30,
    name: 'Carrier Integration',
    code: 'CARRIER_INTEGRATION',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'All areas within Carrier Integration'
  },
  {
    id: 31,
    name: 'Zones',
    code: 'ZONE',
    crud: false,
    create: false
  },
  {
    id: 32,
    name: 'Budget Management System',
    code: 'BUDGET_MANAGEMENT_SYSTEM',
    crud: false,
    create: false,
    read: false,
    update: false,
    delete: false,
    tooltip: 'Manage And Modify Accounts In Budget Management System'
  }
]

// fetch permissions from session storage for current admin
const getPermissions = () => {
  const permissions = JSON.parse(sessionStorage.getItem('admin_permissions'))

  return permissions
}

// check if current admin has the given permission
export const hasPermission = permission => {
  const permissions = getPermissions()
  // permissions is false if super admin
  if (permissions === false) {
    return true
  }
  if (permissions && permissions.includes(permission)) {
    return true
  } else if (!Array.isArray(permissions) && !permissions) {
    return true
  } else {
    return false
  }
}
